export default function getQueryParam({location, key}) {
  const params = new URLSearchParams(location.search)
  const value = params.get(key)
  if (!value) return
  const decoded = decodeURIComponent(value)
  return decoded
}
